// naturalWidth is density-corrected for srcset images. Inspect decoded pixels
// to recognize YouTube's 120px missing-image response even in a wide slot.
// This reuses the decoded image and never makes another network request.
export const readThumbnailWidth = (image: HTMLImageElement, done: (width: number) => void) => {
  const source = image.currentSrc || image.src
  const src = image.src
  const srcset = image.srcset
  const finish = (width: number) => {
    if ((image.currentSrc || image.src) === source && image.src === src && image.srcset === srcset) {
      done(width)
    }
  }
  if (!image.srcset || typeof createImageBitmap !== 'function') {
    finish(image.naturalWidth)
    return
  }
  void createImageBitmap(image)
    .then((bitmap) => {
      const width = bitmap.width
      bitmap.close()
      finish(width)
    })
    .catch(() => finish(image.naturalWidth))
}
